import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // 페이지 이동을 위한 useNavigate
import './NoticeWrite.css';
import { Banner } from '../../../components/Banner/Banner';
import topImage from '../../../assets/images/BannerTop.png';
import { Footer } from '../../../components/Footer/Footer';
import { Navbar } from '../../../components/Navbar/Navbar';


// alert 대신 사용할 간단한 모달 컴포넌트
const Modal = ({ message, onClose }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <p>{message}</p>
                <button onClick={onClose} className="modal-close-btn">확인</button>
            </div>
        </div>
    );
};

export const NoticeWrite = () => {
    // 상태 변수 정의
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate(); // 페이지 이동 훅 사용

    // 로그인 되지 않은 사용자가 직접 URL로 접근하면 로그인 페이지로 이동시킴
    useEffect(() => {
    const token = localStorage.getItem('token');
    console.log("📍 [체크] 현재 저장된 토큰:", token);
    console.log("📍 [체크] 요청 보낼 주소(BOARD_URL):", BOARD_URL);

    if (!token) {
        console.log("❌ 토큰이 없어서 튕깁니다.");
        setModalMessage('로그인 후 이용 가능합니다.');
        setShowModal(true);
        setTimeout(() => navigate('/adLogin', { replace: true }), 800);
    }
}, [navigate, BOARD_URL]);

    // 모달을 닫는 함수
    const closeModal = () => {
        setShowModal(false);
        setModalMessage('');
    };

    // 게시물 작성 및 서버로 전송하는 비동기 함수
    const createPost = async () => {
        // 필수 입력 필드 확인
        if (!title.trim() || !content.trim()) {
            setModalMessage('제목과 내용을 모두 입력해 주세요.');
            setShowModal(true);
            return;
        }

        const token = localStorage.getItem('token');
        if (!token) {
            setModalMessage('로그인 먼저 해주세요.');
            setShowModal(true);
            return;
        }

        try {
            const res = await fetch(`${BOARD_URL}/posts`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({ title, content }),
            });

            const data = await res.json();
            if (res.ok) {
                setModalMessage('게시물이 성공적으로 작성되었습니다.');
                setShowModal(true);
                // 1.5초 후 공지사항 목록 페이지로 이동
                setTimeout(() => {
                    navigate('/notice');
                }, 1500);
            } else if (res.status === 401) {
                setModalMessage('로그인이 만료되었습니다. 다시 로그인해 주세요.');
                setShowModal(true);
                setTimeout(() => navigate('/adLogin', { replace: true }), 800);
            } else {
                setModalMessage(data.message || '게시물 작성에 실패했습니다.');
                setShowModal(true);
            }
        } catch (err) {
            console.error(err);
            setModalMessage('서버와 통신 중 오류가 발생했습니다.');
            setShowModal(true);
        }
    };

    return (
        <>
            <Navbar />
            <Banner title="공지사항" />

            <div className="adNotice-container">

                <input
                    className="adNotice-input"
                    type="text"
                    placeholder="제목을 입력해 주세요."
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                />

                <textarea
                    className="adNotice-textarea"
                    placeholder="내용을 입력하세요."
                    value={content}
                    onChange={e => setContent(e.target.value)}
                />

                <div className="adNotice-btn-wrap">
                    <button
                        className="adNotice-btn"
                        onClick={createPost} // 수정된 부분: onClick에 함수 이름을 바로 전달
                    >
                        등록
                    </button>
                </div>
            </div>

            <Footer />
            {showModal && <Modal message={modalMessage} onClose={closeModal} />}
        </>
    );
};
